<div class="sum-detail" data-qa-block="transaction-sum">
  <div class="detail-row" data-qa="buy-sum">
    {{ 'kkms.kkm.report.operation.operationType.buy' | translate }}:
    {{ transactionTotalResult?.BUY.sum || 0 | kzCurrencyDecimal }}
  </div>
  <div class="detail-row" data-qa="sell-sum">
    {{ 'kkms.kkm.report.operation.operationType.sell' | translate }}:
    {{ transactionTotalResult?.SELL.sum || 0 | kzCurrencyDecimal }}
  </div>
  <div class="detail-row" data-qa="buy-retun-sum">
    {{ 'kkms.kkm.report.operation.operationType.buy_return' | translate }}:
    {{ transactionTotalResult?.BUY_RETURN.sum || 0 | kzCurrencyDecimal }}
  </div>
  <div class="detail-row" data-qa="sell-return-sum">
    {{ 'kkms.kkm.report.operation.operationType.sell_return' | translate }}:
    {{ transactionTotalResult?.SELL_RETURN.sum || 0 | kzCurrencyDecimal }}
  </div>
</div>
